import React, { useEffect, useState } from 'react';
import { useParams }                  from 'react-router';
import PropTypes 					  from 'prop-types';

import ActorProfileRecommendations 	   from '../ActorProfileRecommendations';
import ActorPromotedVideo              from './ActorPromotedVideo';
import GuestAccess 					   from '../../../utils/GuestAccess';
import ProfileVideosBlock 		  	   from '../../Profile/VideosBlock/ProfileVideosBlock';
import VideoRecommendationsGridByActor from '../../VideoRecommendations/VideoRecommendationsGridByActor';

import Translations    from '../../../utils/Translations';
import ReloadHelper    from '../../../utils/ReloadHelper';
import UrlBuilder 	   from '../../../utils/UrlBuilder';

const URL_PARAMS = {
	TAG:   'tag',
};

const onVip30Click = (e) => ReloadHelper.reload(UrlBuilder.buildVIP30Url(), e);

const ActorProfileVideosOverview = ({ actorData, isClassics, navigateTo, location, setPromotedVideo }) => {

    const promotedVideo     = actorData.promotedVideo;

    const [selectedTagGroup, setSelectedTagGroup] = useState("");
    const params = useParams();

    useEffect(() => {
		const urlParams = new URLSearchParams(location?.search);
		const tag 		= params.tagGroup || urlParams.get(URL_PARAMS.TAG) || "";
		setSelectedTagGroup(decodeURIComponent(tag));
    }, [location, params.tagGroup]);

    const onGalleryClick = () => {
        GuestAccess.onContentAccess({
            needAvs: promotedVideo.needAvs,
            needVip: promotedVideo.needVip,
            needLogin: false,
            ignorePaymentFirst: true,
        });
    };

    return (
        <div className="h-pos-relative">
            {(!isClassics && actorData.promotedVideo) &&
                <ActorPromotedVideo
                    actorId           = {actorData.id}
                    actorName         = {actorData.name}
                    isModelFavorite   = {actorData.isFavorite}
                    onGalleryClick    = {onGalleryClick}
                    onVip30Click      = {onVip30Click}
                    promotedVideo     = {actorData.promotedVideo}
                    selectedTagGroup  = {selectedTagGroup}
                    setPromotedVideo  = {setPromotedVideo}
                />
            }

            <div id="pjax-scrollto-pagination"/>
            <ProfileVideosBlock
                actorId					= {actorData.id}
                actorHasClassics		= {actorData.actorHasClassics}
                actorName				= {actorData.name}
                availableTagGroups		= {actorData.availableTagGroups}
                initialIsActorOnline	= {actorData.isOnline}
                isClassics				= {isClassics}
                isSeoProfileVideoFilter = {actorData.isSeoProfileVideoFilter}
                isVideoActor			= {actorData.isVideoActor}
                params                  = {params}
                messagePrice			= {actorData.prices ? actorData.prices.message : 0}
                multiChatPrice			= {actorData.prices ? actorData.prices.video : 0}
                navigateTo				= {navigateTo}
                searchTag	        	= {selectedTagGroup}
            />
            <section className="container-block--actor-grid -margin-bottom-lg -margin-top-sm">
                <div className="media-panel container-block -margin-bottom-lg">
                    <div className="context-box--actor-profile clearfix">
                        <h2
							className="context-box__title h-left"
							dangerouslySetInnerHTML={{ __html: Translations.get('MediaPanelVideoAlbumRecommendations') }}
						/>
                    </div>
                    <VideoRecommendationsGridByActor
                        actorId			 = {actorData.id}
                        actorName		 = {actorData.name}
                        lazyImageLoading = {true}
                        sameActor		 = {false}
                    />
                </div>
            </section>
            <ActorProfileRecommendations actorId={actorData.id} />
        </div>
    );
};

ActorProfileVideosOverview.propTypes = {
    actorData:        PropTypes.object.isRequired,
    promotedVideo:    PropTypes.object,
    isClassics:       PropTypes.bool,
    location:         PropTypes.object,
    navigateTo:       PropTypes.func.isRequired,
    setPromotedVideo: PropTypes.func,
};

export default ActorProfileVideosOverview;
